import { $t } from "@klondpay/locales";
import { Redirect } from "@klondpay/layout";
const Layout = () => import("/@/layout/index.vue");

const remainingRouter = [
  {
    path: "/login",
    name: "login",
    component: () => import("/@/views/login/index.vue"),
    meta: {
      title: $t("menus.hslogin"),
      showLink: false,
      rank: 101
    }
  },
  {
    path: "/update-password",
    name: "UpdatePassword",
    component: () => import("/@/views/login/update-password.vue"),
    meta: {
      title: $t("menus.hsUpdatePassword"),
      showLink: false,
      hasAuth: true,
      rank: 102
    }
  },
  {
    path: "/redirect",
    component: Layout,
    meta: {
      icon: "data-board",
      title: $t("menus.hshome"),
      showLink: false,
      rank: 104
    },
    children: [
      {
        path: "/redirect/:path(.*)",
        name: "redirect",
        component: Redirect
      }
    ]
  },
  {
    path: "/user-info",
    name: "userInfo",
    component: () => import("/@/views/login/user-info.vue"),
    meta: {
      title: $t("个人中心"),
      showLink: false,
      hasAuth: true,
      rank: 102
    }
  }
];

export default remainingRouter;
